<template>
    <div class="content" style="postion:absolute;bottom:0;left:0" id="equipmentDetail">
        <div slot="header" class="clearfix">
             <span><i class="el-icon-collection-tag"></i>{{$t('equipmentmanagement.equipmentDetail')}}</span>
             <el-button type="common" icon="el-icon-arrow-left" style="position: absolute;left:110px;margin-top: 8px;" :class="$i18n.locale=='zh'?'':'header_button'" v-on:click="$emit('ifDetail', true)">{{$t('back')}}</el-button>
        </div>
        <div  class="content_bd">
            <el-card  style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
                <el-form style="margin: 10px 10px 10px 10px;" v-if="isAdmin == true">
                    <el-row :gutter="24" style="text-align: left;background: #d2dfe8;display:flex;align-items: center;-webkit-align-items: center;min-height:30px!important;height:45px!important">
                        <el-col :span="3">
                            <el-form-item :label="$t('dtuNo')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label-width="formLabelWidth">{{equipData.dtuNumber}}</el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentName')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item  :label-width="formLabelWidth" class="spanStylee">{{equipData.name}}</el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentType')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item  :label-width="formLabelWidth">{{equipData.equipmentTypeName}}</el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item label="断网时间" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label-width="formLabelWidth">{{equipData.latestDataTime}}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24" style="text-align: center;background:rgb(245 246 246);min-height:30px!important;height:45px!important">
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentmanagement.mainBoardVersion')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item  :label-width="formLabelWidth" style="text-align:left">{{equipData.hardwareVersion}}</el-form-item>
                        </el-col>
                        <el-col :span="3" >
                            <el-form-item :label="$t('equipmentmanagement.androidVersion')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item  :label-width="formLabelWidth" style="text-align:left">{{equipData.version}}</el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentmanagement.simCardNO')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item  :label-width="formLabelWidth" style="text-align:left" v-if="equipData.simCard">{{equipData.simCard.number}}</el-form-item>
                        </el-col>
                      <!--I remove quality check.Nobody care it )-->
                      <el-col :span="3">
                        <el-form-item label="设备分组" :label-width="formLabelWidth" class="bold"></el-form-item>
                      </el-col>
                        <el-col :span="3">
                          <el-form-item :label-width="formLabelWidth" style="text-align:left">{{equipData.group}}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24" style="background:#d2dfe8;text-align:left;min-height:30px!important;height:45px!important">
                        <el-col :span="3" >
                            <el-form-item :label="$t('equipmentmanagement.equipmentAddress')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="9" style="padding-left: 0px;">
                            <el-form-item style="text-align:left">{{equipData.autoLocation}}</el-form-item>
                        </el-col>
                        <el-col :span="3" >
                            <el-form-item :label="$t('equipmentmanagement.manualPositioning')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="9" style="padding-left: 0px;">
                            <el-form-item style="text-align:left">{{equipData.manualAddress==null?$t('none'):equipData.manualAddress}}</el-form-item>
                        </el-col>
                    </el-row>
                  <el-row :gutter="24" style="text-align: center;background:rgb(245 246 246);min-height:30px!important;height:45px!important">
                    <el-col :span="3">
                      <el-form-item :label="$t('equipmentNo')" :label-width="formLabelWidth" class="bold"></el-form-item>
                    </el-col>
                    <el-col :span="3" style="padding-left: 0px;">
                      <el-form-item style="text-align:left">{{equipData.number}}</el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-form style="margin: 10px 10px 10px 10px;" v-if="isAdmin == false">
                    <el-row :gutter="24" style="text-align: left;background: #d2dfe8;display:flex;align-items: center;-webkit-align-items: center;min-height:30px!important;height:45px!important">
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentName')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item :label-width="formLabelWidth">{{equipData.name}}</el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentType')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item  :label-width="formLabelWidth">{{equipData.equipmentType==undefined?'':equipData.equipmentType.name}}</el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentmanagement.latestSubmittedData')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item :label-width="formLabelWidth">{{equipData.latestDataTime}}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24" style="text-align: center;background:rgb(245 246 246);min-height:30px!important;height:45px!important">
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentmanagement.mainBoardVersion')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item  :label-width="formLabelWidth" style="text-align:left">{{equipData.hardwareVersion}}</el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item :label="$t('equipmentmanagement.androidVersion')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item  :label-width="formLabelWidth" style="text-align:left">{{equipData.version}}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24" style="text-align: left;background: #d2dfe8;display:flex;align-items: center;-webkit-align-items: center;min-height:30px!important;height:45px!important">
                        <el-col :span="2.5" >
                            <el-form-item :label="$t('equipmentmanagement.equipmentAddress')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="7" >
                            <el-form-item style="text-align:left">{{equipData.autoLocation}}</el-form-item>
                        </el-col>
                        <el-col :span="2.5" v-if="this.$account.data.accountName!='雀巢'">
                            <el-form-item :label="$t('equipmentmanagement.manualPositioning')" :label-width="formLabelWidth" class="bold"></el-form-item>
                        </el-col>
                        <el-col :span="7" v-if="this.$account.data.accountName!='雀巢'">
                            <el-form-item style="text-align:left">{{equipData.manualAddress==null?$t('none'):equipData.manualAddress}}</el-form-item>
                        </el-col>
                    </el-row>
                  <el-row :gutter="24" style="text-align: center;background:rgb(245 246 246);min-height:30px!important;height:45px!important">
                    <el-col :span="3">
                      <el-form-item :label="$t('equipmentNo')" :label-width="formLabelWidth" class="bold"></el-form-item>
                    </el-col>
                    <el-col :span="3" style="padding-left: 0px;">
                      <el-form-item style="text-align:left">{{equipData.number}}</el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
            <el-row :gutter="24" style="text-align: left;margin-bottom:0px!important;margin-top:10px;">
                <el-col :span="20">
                    <el-button type="common" size="small" style="padding: 8px 12px;" @click="saledialogShow()"><i class="iconfont el-icon-xiaoshou-hei_huaban el-icon--left"></i>{{$t('equipmentmanagement.salesDetail')}}</el-button>
                    <el-button type="guzhang" size="small" style="padding: 8px 12px;" @click="gzdialogShow()"><i class="iconfont el-icon-guzhang1 el-icon--left"></i>{{$t('equipmentmanagement.faultList')}}</el-button>
                    <el-button type="common" size="small" style="padding: 8px 12px;" v-if="this.$account.data.isAdmin" @click="showUpLogDialog()"><i class="el-icon-upload el-icon--left"></i>{{$t('equipmentmanagement.logUpload')}}</el-button>
                    <el-button type="common" size="small" style="padding: 8px 12px;" v-if="this.$account.data.isAdmin" @click="loadLogList()"><i class="el-icon-document el-icon--left"></i>{{$t('equipmentmanagement.viewDeviceLog')}}</el-button>
                    <el-button type="common" size="small" style="padding: 8px 12px;" @click="showQrCode()"><i class="el-icon-document el-icon--left"></i>{{$t('equipmentmanagement.checkPaymentQRCode')}}</el-button>
                </el-col>
            </el-row>
            </el-card >
            <el-card v-show="issale" style="margin-top:10px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;position:relative;height: 70vh">
                    <el-row>
                        <el-col :span="24">
                            <el-table
                            ref="multipleTable"
                            :data="saleList"
                            stripe
                            tooltip-effect="dark"
                            style="width: 100%;"
                            :page-size="pageSize"
                            :pager-count="11"
                            max-height="330"
                            v-loading="saleListloading"
                            >
                                <el-table-column
                                    type="index"
                                    :label="$t('serialNo')"
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    prop="orderNo"
                                    width="270"
                                    :label="$t('saledata.orderNO')">
                                </el-table-column>
<!--                                <el-table-column-->
<!--                                    :label="$t('saledata.transactionMode')"-->
<!--                                    :filters="[{text: '付费模式', value: true}, {text: '免费模式', value: false}]"-->
<!--                                    :filter-method="filterHandler"-->
<!--                                    :filter-multiple="false"-->
<!--                                    >-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <span  v-if="scope.row.orderForm == 0">{{$t('saledata.contactType')}}</span>-->
<!--                                        <span  v-if="scope.row.orderForm == 1">{{$t('saledata.nonContactType')}}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <el-table-column
                                    :label="$t('saledata.paymentMethod')"
                                    width="150"
                                    >
                                    <template slot-scope="scope">
                                        <span  v-if="scope.row.payMode == 0">{{$t('saledata.free')}}</span>
                                        <span  v-if="scope.row.payMode == 1">{{$t('saledata.wechat')}}</span>
                                        <span  v-if="scope.row.payMode == 2">{{$t('saledata.aliPay')}}</span>
                                        <span  v-if="scope.row.payMode == 3">维尔数字</span>
                                        <span  v-if="scope.row.payMode == 4">苏银支付(聚合)</span>
                                        <span  v-if="scope.row.payMode == 5">苏银支付(数币)</span>
                                        <span  v-if="scope.row.payMode == 6">泰银支付(聚合)</span>
                                        <span  v-if="scope.row.payMode == 7">泰银支付(数币)</span>
                                        <span  v-if="scope.row.payMode == 8">新蓝支付(食堂卡)</span>
                                        <span  v-if="scope.row.payMode == 9">新蓝支付(微信)</span>
                                        <span  v-if="scope.row.payMode == 10">新蓝支付(支付宝)</span>
                                        <span  v-if="scope.row.payMode == 11">富友(微信)</span>
                                        <span  v-if="scope.row.payMode == 12">富友(支付宝)</span>
                                        <span  v-if="scope.row.payMode == 13">企团</span>
                                        <span  v-if="scope.row.payMode == 14">刷卡</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="EquipmentName"
                                    :label="$t('equipmentName')"
                                    width="150"
                                    :show-overflow-tooltip="true"
                                    >
                                    <template slot-scope="scope">
                                            <span  @click="handleTableItemClick(scope.row)" >{{scope.row.equipment ==null ?'':scope.row.equipment.name}}</span>
                                    </template>
                                </el-table-column>
<!--                                <el-table-column-->
<!--                                    prop="EquipmentNo"-->
<!--                                    :label="$t('equipmentNo')"-->
<!--                                    :show-overflow-tooltip="true"-->
<!--                                    >-->
<!--                                    <template slot-scope="scope">-->
<!--                                            <span>{{scope.row.equipment ==null ?'':scope.row.equipment.number}}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                              <el-table-column
                                :label="$t('keyNumber')"
                                prop="keySort"
                              >
                              </el-table-column>
                              <el-table-column
                                :label="$t('setAmount')"
                              >
                                <template slot-scope="scope">
                                  <span>{{scope.row.totalAmount ==null ?$t('none'):scope.row.totalAmount}}</span>
                                </template>
                              </el-table-column>
                                <el-table-column
                                    prop="DrinkName"
                                    :label="$t('beverageName')"
                                    width="160"
                                    >
                                    <template slot-scope="scope">
                                            <span>{{scope.row.goodName}}</span>
                                    </template>
                                </el-table-column>
<!--                                <el-table-column-->
<!--                                    prop="CupNum"-->
<!--                                    :label="$t('cupTypeSerialNo')"-->
<!--                                    >-->
<!--                                    <template slot-scope="scope">-->
<!--                                            <span v-if="scope.row.cupType">{{scope.row.cupType ==null ?'':scope.row.cupType.number}}</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                            <el-table-column
                                prop="CupName"
                                :label="$t('saledata.cupTypeName')"
                                >
                                <template slot-scope="scope">
                                        <span v-if="scope.row.cupType" >{{scope.row.cupType.cupSize ==null ?'':scope.row.cupType.cupSize.name}}</span>
                                </template>
                            </el-table-column>
<!--                            <el-table-column-->
<!--                                prop="cupAmountFineAdjustment"-->
<!--                                :label="$t('cupTypePercentage')"-->
<!--                                >-->
<!--                            </el-table-column>-->
                              <el-table-column
                                :label="$t('paidInAmount')"
                              >
                                <template slot-scope="scope">
                                  <span>{{scope.row.orderStatus ==2?scope.row.actualAmount:0}}</span>
                                </template>
                              </el-table-column>
                                <el-table-column
                                    prop="orderTime"
                                    width="200"
                                    :label="$t('saledata.paymentTime')"
                                    sortable="sort"
                                    >
                                </el-table-column>
                            <el-table-column
                                prop="orderStatus"
                                :label="$t('saledata.orderStatus')"
                                fixed="right"
                                width="400"
                                :filters="[{text: $t('saledata.unPaid'), value: 0}, {text: $t('saledata.paid'), value: 1}, {text: $t('equipmentmanagement.inShipment'), value: 2}, {text: $t('equipmentmanagement.transactionCompletion'), value: 3}, {text: $t('saledata.refundInProgress'), value: 4}, {text: $t('saledata.refunded'), value: 5}]"
                                :filter-method="filterHandler"
                                :filter-multiple="false"
                                >
                                <template slot-scope="scope">
                                    <span  v-if="scope.row.orderStatus == 0">{{$t('saledata.unPaid')}}</span>
                                    <span  v-if="scope.row.orderStatus == 1">{{$t('saledata.paid')}}</span>
                                    <span  v-if="scope.row.orderStatus == 2">{{$t('saledata.commodityDeliverySucceeded')}}</span>
                                    <span  v-if="scope.row.orderStatus == 3">{{$t('saledata.commodityDeliveryFailed2')}}</span>
                                    <span  v-if="scope.row.orderStatus == 4">{{$t('saledata.refunded')}}</span>
                                </template>
                            </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="23" style="text-align:right">
                            <el-pagination
                              background
                            @size-change="handleSizeChangesale"
                            @current-change="handleCurrentChangesale"
                            :current-page="currentPage4sale"
                        :page-sizes="[10, 20,50,100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalSaleCount">
                            </el-pagination>
                        </el-col>
                        <el-col :span="1" style="margin-top:2%;">
                            <el-button size="mini" class="gobutton">GO</el-button>
                        </el-col>
                    </el-row>
                </el-card>
               <el-card v-show="isfault" style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
                    <el-row>
                        <el-col :span="24">
                            <el-table
                            ref="multipleTable"
                            :data="faultInfoList"
                            stripe
                            tooltip-effect="dark"
                            style="width: 100%"
                             max-height="200"
                            :page-size="pageSize"
                            v-loading="saleListloading"
                            :pager-count="11"
                            >
                                <el-table-column
                                    type="index"
                                    :label="$t('serialNo')"
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    :label="$t('equipmentNo')"
                                    >
                                    <template slot-scope="scope">
                                        <span>{{scope.row.equipment==null?'':scope.row.equipment.number}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                  :label="$t('equipmentName')"
                                  :show-overflow-tooltip="true"
                                    >
                                    <template slot-scope="scope">
                                        <span>{{scope.row.equipment==null?'':scope.row.equipment.name}}</span>
                                    </template>
                                </el-table-column>
                           <el-table-column
                                prop="code"
                                :label="$t('equipmentmanagement.faultCode')"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.faultDescription" >{{scope.row.faultDescription.code}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="reason"
                                :label="$t('equipmentmanagement.faultInformation')"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.faultDescription" >{{scope.row.faultDescription.description}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="startTime"
                                :label="$t('equipmentmanagement.faultTime')"
                                sortable
                                >
                            </el-table-column>
                            <el-table-column
                                prop="endTime"
                                :label="$t('equipmentmanagement.endTime')"
                                sortable
                                >
                            </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                    <el-row>
                    <el-col :span="24" style="margin-top:2%;text-align:center">
                        <el-pagination
                          background
                        @size-change="handleSizeChangegz"
                        @current-change="handleCurrentChangegz"
                        :current-page="currentPage4gz"
                        :page-sizes="[10, 20,50,100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalFaultCount">
                        </el-pagination>
                    </el-col>
                    </el-row>
                </el-card>

            <!-- 设备二维码对话框 -->
            <el-dialog
            :title="$t('equipmentmanagement.checkPaymentQRCode')"
            :visible.sync="DialogERCodeVisible"
            :close-on-click-modal="false"
            style="text-align: left;"
            :append-to-body="true"
            >
                <img src="@/assets/images/qrcode.jpg" style="width:100%;height:100%;"/>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="DialogERCodeVisible = false">{{$t('cancel')}}</el-button>
                    <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;" @click="DialogERCodeVisible = false">{{$t('okSpace')}}</el-button>
                </span>
            </el-dialog>


            <!-- 按键设置 -->
            <el-dialog
            :title="$t('equipmentmanagement.statisticsOfKeyCupBeating')"
            :visible.sync="menuConfigDialogVisible"
            :close-on-click-modal="false"
            style="text-align: left;"
            :append-to-body="true"
            width="40%"
            >
                <el-card  style="margin-top:10px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
                    <el-form style="margin:0px 10px 10px 0px;max-height:520px;overflow-y:auto;overflow-x:hidden">
                        <div style="font-size:16px;font-weight:bold">{{$t('equipmentmanagement.totalCups')}}： {{equipData.totalCup}}</div>
                        <el-row :gutter="24" style="text-align: left;">
                            <el-col :span="4" :offset="2">{{$t('keyNumber')}}：</el-col>
                            <el-col :span="6" :offset="1">{{$t('beverageName')}}： </el-col>
                            <el-col :span="4" :offset="1">{{$t('saledata.cupTypeName')}}： </el-col>
                            <el-col :span="6" :offset="1">{{$t('equipmentmanagement.numberOfCups')}}:  </el-col>
                        </el-row>
                        <el-row :gutter="24" style="text-align: left;" v-for="(item,index) in BtnConfigList" :key="index">
                            <el-col :span="4" :offset="2">{{item.sort}}&nbsp;</el-col>
                            <el-col :span="6" :offset="1">{{item.cupType&&item.cupType.beverage?item.cupType.beverage.name:''}}&nbsp;</el-col>
                            <el-col :span="4" :offset="1">{{item.cupType&&item.cupType.cupSize?item.cupType.cupSize.name:''}}&nbsp;</el-col>
                            <el-col :span="6" :offset="1">{{item.totalCup}}&nbsp;</el-col>
                        </el-row>
                    </el-form>
                    <div style="text-align: right;">
                        <el-button type="primary" style="margin-right: 20px;color: #eceeef;background-color: #315a7d;" @click="addBtnConfig(true)"  v-preventReClick>{{$t('confirm')}}</el-button>
                    </div>
                </el-card>
            </el-dialog>

            <!-- 设备日志 -->
            <el-dialog
            :title="$t('equipmentmanagement.equipmentLog')"
            :visible.sync="showLogDialog"
            :close-on-click-modal="false"
            style="text-align: left;"
            :append-to-body="true"
            width="40%"
            >
                <el-card  style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
                    <el-form style="margin:0px 10px 10px 0px;max-height:520px;overflow-y:auto;overflow-x:hidden">
                        <div style="font-size:16px;font-weight:bold">{{$t('equipmentmanagement.fileList')}}：</div>
                        <el-row :gutter="24" style="text-align: left;" v-for="(item,index) in fileLogList" :key="index">
                            <el-col :span="3" :offset="1">{{index+1}}&nbsp;</el-col>
                            <el-col :span="13" class="spanStyle" ><el-link :href="$prefix+item.path" target="_blank">{{item.name}}123</el-link></el-col>
                            <el-col :span="3"><el-button type="danger" icon="el-icon-delete" circle @click="deleteFileLog(item.id)"></el-button></el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-dialog>
          <!-- 二维码 -->
          <el-dialog
            :title="$t('equipmentmanagement.paymentQRCode')"
            :visible.sync="showQrCodeDialog"
            v-if="showQrCodeDialog"
            :close-on-click-modal="false"
            :append-to-body="true"
            width="40%"
            style="text-align: center"
          >
            <el-card  style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;" id="test">
              <div ref="qrCodeUrl" id="qrCodeCanvas"></div>
            </el-card>
          </el-dialog>
          <el-dialog
            :title="$t('equipmentmanagement.timeSelection')"
            :visible.sync="upLogDialogVisible"
            :close-on-click-modal="false"
            style="text-align: left;"
            :append-to-body="true"
            width="40%"
          >
            <el-card  style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
              <el-form>
                <el-row :gutter="24" style="text-align: left;">
                  <el-form-item :label="$t('equipmentmanagement.selectTime')+'：'">
                    <el-date-picker
                      v-model="upTime"
                      value-format="yyyy-MM-dd hh:mm:ss"
                      type="datetimerange"
                      range-separator="-"
                      :start-placeholder="$t('startTime')"
                      :end-placeholder="$t('endTime')"
                    >
                    </el-date-picker>
                    <el-button @click="uploadLog">{{$t('upload')}}</el-button>
                  </el-form-item>
                </el-row>
              </el-form>
            </el-card>
          </el-dialog>
        </div>
    </div>
</template>

<script>
import speeddelay from '../speeddelay/speeddelay.vue';
import QRCode from 'qrcodejs2'
export default {
  components: { speeddelay },
  props:['equipData'],
  watch:{
    equipData:{
      handler(newValue, oldValue) {
            this.equipData =  newValue;          //父组件updateTime对象改变会触发此函数
　　　　},
　　　　deep: true
    }
  },
    data(){
        return {
            formLabelWidth:'120',
            query:new Object(),
            DialogERCodeVisible: false,
            SaleDialogVisible: false,
            MalDialogVisible:false,
            DrinkDialogVisible:false,
            assignedCupDialogVisible:false,
            menuConfigDialogVisible:false,
            showBtnConfigDiag:false,
            cupTotalDialogVisible:false,
            showLogDialog:false,
            showQrCodeDialog:false,
            currentPage4:1,
            currentPage4gz:1,
            currentPage4sale:1,
            cupTypeid:0,
            btnid:0,
            saleListloading:true,
            totalSaleCount:0,
            cupTypeTotalCount:0,
            saleList:[],
            issale:false,
            pageSize:10,
            pageIndex:1,
            value: '',
            equipinfoList: [],
            cupTypesCount:0,
            faultInfoList: [],
            isfault:false,
            cupinfoList:[],
            cupTypesLists:[],
            selectedCupTypeList:[],
            BtnConfigList:[],
            fileLogList:[],
            totalFaultCount: 0,
            totalBtnConfigCount:0,
            isAdmin:true,
            activeName: 'first',
            upLogDialogVisible:false,// 上传日志的弹窗
            upTime:''
        }
    },
    mounted() {
        this.loadEquipInfoList(this.equipData.id);
       if(this.$account.data.isAdmin){
            this.isAdmin = true;
        }else{
            this.isAdmin = false
        }
    },
    methods:{
        handleTableItemClick(e){

        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        addclass(i){
            switch(i){
                case "正常": return 'statusonline';
                case "异常": return 'statusoffline'
            }
        },
        handleSizeChangegz(e){
            this.pageSize=e;
            this.loadFaultInfoList(1,this.equipData.number);
        },
        handleCurrentChangegz(e){
            this.pageIndex = e;
            this.currentPage4gz = e;
            this.loadFaultInfoList(e,this.equipData.number);
        },
        handleSizeChangesale(e){
            this.pageSize=e;
            this.loadSaleList(1,{dtuNo:this.equipData.dtuNumber});
        },
        handleCurrentChangesale(e){
            this.pageIndex = e;
            this.currentPage4sale =e;
            this.loadSaleList(e,{dtuNo:this.equipData.dtuNumber});
        },
        handleSizeChangepf(e){
            this.pageSize=e;
            this.loadAssignedCupType();
        },
        handleCurrentChangepf(e){
            this.pageIndex = e;
            this.loadAssignedCupType();
        },
        //获取设备详情信息
        loadEquipInfoList(id){
            let that = this;
            this.$httpservice.get("api/Equipment/Get",{id:id}).then(
                function (data) {
                    if(data.body.code=="200"){
                        that.equipinfoList = data.body.data;
                        if(that.equipinfoList.cupTypes){
                            that.cupTypesLists = that.equipinfoList.cupTypes
                            that.cupTypesCount = that.equipinfoList.cupTypes.length;
                        }
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
        saledialogShow(){
            //this.SaleDialogVisible = true;
            this.currentPage4sale = 1;
            this.loadSaleList(1,{dtuNo:this.equipData.dtuNumber});
        },
        //加载销售数据列表
        loadSaleList(pageIndex,parameter){
            this.isfault = false
            this.issale =true
            this.saleListloading = true;
            this.param = {
                pageIndex:pageIndex,
                pageSize:this.pageSize,
                ...parameter
            };
            let that = this;
            this.$httpservice.get("api/Order/List",that.param).then(
                function (data) {
                    that.saleListloading = false;
                    if(data.body.code=="200"){
                        that.saleList = data.body.data;
                        that.$forceUpdate()
                        that.totalSaleCount = data.body.totalCount;
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    that.saleListloading = false;
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
        //加载已分配配方信息
        loadAssignedCupType(){
            // console.log(11111111111)
            this.assignedCupDialogVisible = true;
            this.param = {
                pageIndex:this.pageIndex,
                pageSize:this.pageSize,
                dtuNo:this.equipinfoList.dtuNumber
            };
            let that = this;
            this.$httpservice.get("api/Equipment/CupTypes",that.param).then(
                function (data) {
                    if(data.body.code=="200"){
                        that.cupinfoList = data.body.data;
                        that.cupTypeTotalCount = data.body.totalCount;
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
        gzdialogShow(){
            this.currentPage4gz = 1;
            this.loadFaultInfoList(1,this.equipData.number)
        },
        //获取故障信息
        loadFaultInfoList(pageIndex,number){
            this.issale = false
            this.isfault = true
            this.saleListloading = true;
            //this.MalDialogVisible = true;
            let param = {
                pageIndex:pageIndex,
                pageSize:this.pageSize,
                equipmentNumber:number
            }
            let that = this;
            this.$httpservice.get("api/Equipment/FaultInfos",param).then(
                function (data) {
                    if(data.body.code=="200"){
                        that.saleListloading = false;
                        that.faultInfoList = data.body.data;
                        that.totalFaultCount = data.body.totalCount;
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
        //获取按键信息
        loadBtnConfigList(){
            this.menuConfigDialogVisible = true;

            let that = this;
            this.$httpservice.get("api/Equipment/KeyConfigs",{dtuNo:this.equipData.dtuNumber}).then(
                function (data) {
                    if(data.body.code=="200"){
                        that.BtnConfigList = data.body.data;
                        that.totalBtnConfigCount = data.body.totalCount;
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        },
      // 打开日志上传的弹窗
        showUpLogDialog(){
          // 清空所有条件
          this.upTime = ''
          this.upLogDialogVisible = true
        },
        //上传日志
        uploadLog(){
          let content = {
            startTime:'',
            endTime:''
          }
          // 有值赋值，没值不赋值
          if(this.upTime){
            content.startTime = this.upTime[0]
            content.endTime = this.upTime[1]
          }
            this.$httpservice.post('api/EquipmentOperation/SendInstruction',{instruction:8,target:this.equipData.dtuNumber,type:0,content:content}).then(result => {
                if(result.data.code=='200'){
                    this.$message.success(this.$t('operationSucceeded'))
                }else{
                    this.$message.error(this.$t('saveFailed'))
                }
            });
        },
        //加载设备日志
        loadLogList(){
            this.showLogDialog = true;
            this.$httpservice.get('api/File/List',{fileCatalog:5,dtuNo:this.equipData.dtuNumber}).then(res => {
                if(res.data.code=='200'){
                    this.fileLogList = res.data.data
                }else{
                    this.$message.error(this.$t('equipmentmanagement.failedToGetLog'))
                }
            });
        },
      // 展示支付二维码
      showQrCode(){
        this.showQrCodeDialog = true
        // 拼接url只有非接触式
        let dtuNo = this.equipinfoList.dtuNumber
        if(!dtuNo){
          this.$message.error(this.$t('equipmentmanagement.failedToObtainDtuNumberPleaseRefreshAndTryAgain'))
          return
        }
        let url = ''
        if(this.equipinfoList){
          // 判断是带配方库还是不带配方库0安卓不带配方1安卓带配方2dtu
          if(this.equipinfoList.equipmentType.catalog == 1){
            url = 'https://icloud.lhcoffeetime.com/pages/payment/index.html#/ProductDtu?dtuNo='+dtuNo+'&free=0'
          }else if(this.equipinfoList.equipmentType.catalog == 0){
            url = 'https://icloud.lhcoffeetime.com/pages/payment/index.html#/?dtuNo='+dtuNo+'&free=0'
          }else if(this.equipinfoList.equipmentType.catalog == 2){
            url = 'https://icloud.lhcoffeetime.com/pages/payment/index.html#/ProductDtu?dtuNo='+dtuNo+'&free=0'
          }
        }else{
          this.$message.error(this.$t('equipmentmanagement.failedToObtainDeviceParametersPleaseRefreshAndTryAgain'))
          return
        }
        this.$nextTick(function (){
          this.createQrCode(url)
        })
      },
      closeQrCodeDialog(){
        this.showQrCodeDialog = false
      },
      createQrCode(url){
          new QRCode(this.$refs.qrCodeUrl,{
            text:url,
            width:500,
            height:500,
            colorDark:'#000000',
            colorLight:'#ffffff',
            correctLevel:QRCode.CorrectLevel.H
          })
      },
        //删除设备日志
        deleteFileLog(id){
            let that = this;
            this.$httpservice.post("api/File/Delete",[id]).then(
                function (data) {
                    if(data.body.code=="200"){
                        that.$message({
                                message: that.$t('equipmentmanagement.successfullyDeletedLogFile'),
                                type: 'success'
                        });
                        that.loadLogList()
                    }else{
                        that.$message({
                            message: data.body.msg,
                            type: 'danger'
                        });
                    }
                },
                function (data) {
                    let statusCode = data.status;
                    that.$message({
                        message: that.$t('queryFailedStatusCode')+statusCode,
                        type: 'warning'
                    });
                }
            );
        }
    }
}
</script>

<style scoped lang="less">
#equipmentDetail{
  .el-card{
    margin-top: 0!important;
  }
  .el-card__body{
    padding-bottom: 0!important;
  }
  .el-table__body-wrapper{
    max-height: 220px!important;
  }
}
#qrCodeCanvas{
  width: 500px;// 和生成的二维码一样长
  margin: 0 auto;
}
.contentdetail{
float:right;
    width: 100% !important;
    height: 340px !important;
    padding: 0px !important;
    z-index: 99999999999 !important;
}
.el-row{
    min-height: 30px;
    display:flex;
    align-items: center;
}
.el-form-item {
    margin-bottom: 0px;
}
.longname{
        white-space: nowrap;
    margin: 5px 0px!important;
    overflow-y: hidden!important;
    overflow-x: auto!important;
    text-overflow: ellipsis!important;
}
.longname::-webkit-scrollbar {
  width: 0px!important;
  height: 0px!important;
}
.el-button--menu{color:#fafafa;background-color:rgb(49, 140, 168);border-color:#4888bd}
.el-button--menu:focus,.el-button--menu:hover{background:#dce0e6;border-color:#98adbe;color:#516680}
.el-button--menu.is-active,.el-button--menu:active{background:#dce0e6;border-color:#98adbe;color:#516680}
.el-button--menu:active{outline:0}

.el-button--wechat{color:#fafafa;background-color:rgb(37, 158, 112);border-color:#338f52}
.el-button--wechat:focus,.el-button--wechat:hover{background:#dce0e6;border-color:#98adbe;color:#516680}
.el-button--wechat.is-active,.el-button--wechat:active{background:#dce0e6;border-color:#98adbe;color:#516680}
.el-button--wechat:active{outline:0}

.el-button--guzhang{color:#fafafa;background-color:rgb(117, 33, 22);border-color:#8d2018}
.el-button--guzhang:focus,.el-button--guzhang:hover{background:#dce0e6;border-color:#98adbe;color:#805451}
.el-button--guzhang.is-active,.el-button--guzhang:active{background:#dce0e6;border-color:#98adbe;color:#516680}
.el-button--guzhang:active{outline:0}

.el-button--common{color:#fafafa;background-color:#516680;border-color:#4a5b8b}
.el-button--common:focus,.el-button--common:hover{background:#dce0e6;border-color:#98adbe;color:#805451}
.el-button--common.is-active,.el-button--common:active{background:#dce0e6;border-color:#98adbe;color:#516680}
.el-button--common:active{outline:0}

.statusonline{
    color: green;
}
.statusoffline{
    color: red;
}

.bold{
    font-weight:bold;
}

.lan_font{
    font-size: 14px;
    color: #606266;
}

.item {
  margin-top: 10px;
  margin-right: 20px;
}

.editDiaInput{
    width: 70%;
    margin: 0 0 0 0px;
    font-size: 15px;
}

.editrangeDiaInput{
     width: 25%;
}

.el-form-item {
    margin-top: 5px!important;
    margin-bottom: 5px!important;
}
  .spanStyle {
    width: 400px;
    text-align: center;
    /* margin-bottom: 0px!important; */
    display: inline-block;
    white-space: nowrap;
    margin: 5px 0px;
    overflow-y: hidden;
    overflow-x: auto;
    text-overflow: ellipsis;
    height: 30px;
    line-height: 30px;
}
.spanStyle::-webkit-scrollbar {
  width: 0px!important;
  height: 0px!important;
}

.spanStylee {
    text-align: left;
    /* margin-bottom: 0px!important; */
    display: inline-block;
    white-space: nowrap;
    width: 180px;
    overflow-y: hidden;
    overflow-x: auto;
    text-overflow: ellipsis;
    height: 30px;
    line-height: 30px;
}
.spanStylee::-webkit-scrollbar {
  width: 0px!important;
  height: 0px!important;
}
.header_button{
  left: 150px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/equipment_detail.vue